import React from 'react';

import {pushInteractionTagManager} from '../../services/tagManager';
import {AccreditationLink} from '../AccreditationLink/AccreditationLink';
import './Doubts.style.scss';

export const Doubts = (props) => {
  const openContracts = () => {
    pushInteractionTagManager({
      screenName: 'credenciamento:home',
      elementType: 'select:link:click',
      elementContent: 'none:clique-aqui:duvidas'
    });
  };

  return (
    <div className="questions">
      <div className="doubt">
        <div className="doubt__box-question">
          <div className="doubt__question">
            <h3>Pergunta</h3>
          </div>
          <div>
            <p>
              <strong>Qual a política de credenciamento da Alelo?</strong>
            </p>
          </div>
        </div>
        <div className="doubt__box-answer">
          <div className="doubt__answer">
            <h3>Resposta</h3>
          </div>
          <div>
            <p>
              Estabelecimentos interessados em se habilitar para a aceitação dos
              produtos Alelo devem seguir cinco exigências.
            </p>
            <ul>
              <li>O EC deve possuir CNPJ.</li>
              <li>
                O EC deve possuir conta corrente de pessoa jurídica, que será
                validada e utilizada para recebimentos dos recebíveis referentes
                ao faturamento com os respectivos cartões da Alelo.
              </li>
              <li>
                O EC deve possuir um ramo de atividade (CNAE) compatível com os
                produtos da Alelo.
              </li>
              <li>
                O EC que quer se credenciar para aceitar os cartões regulados
                pelo PAT, deve, obrigatoriamente, ter os CNAEs previstos pelo
                PAT, como: comercialização de refeição ou gêneros alimentícios.
              </li>
              <li>
                Para aceitação dos cartões Alelo Refeição e Alelo Alimentação, o
                EC deve atender as exigências do PAT.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="doubt doubt--margin-top">
        <div className="doubt__box-question">
          <div className="doubt__question doubt__question--invert-colors">
            <h3>Pergunta</h3>
          </div>
          <div>
            <p>
              <strong>Como faço para me credenciar?</strong>
            </p>
          </div>
        </div>
        <div className="doubt__box-answer">
          <div className="doubt__answer doubt__answer--invert-colors">
            <h3>Resposta</h3>
          </div>
          <div>
            <p>
              Para realizar o credenciamento, basta ter seus principais
              documentos em mãos e realizar um cadastro simples em{' '}
              <AccreditationLink {...props}>nossa página</AccreditationLink> ou
              no nosso{' '}
              <a
                className="doubt__link"
                target="_blank"
                href="https://wa.me/message/VCY6ORWF4F3YL1 "
                rel="noreferrer"
              >
                WhatsApp
              </a>{' '}
              <strong>(11 4002 5011)</strong>.
            </p>
            <p className="doubt__answer--no-space">
              Em caso de dúvida, entre em contato com nosso atendimento através
              dos números:
            </p>
            <ul>
              <li>
                <strong>4002 5011 (Capitais e regiões metropolitanas)</strong>
              </li>
              <li>
                <strong>0800 570 5011 (Demais localidades)</strong>
              </li>
            </ul>
            <p className="doubt__answer--no-space">
              <strong>
                Atendimento de segunda a sexta-feira, das 8h às 22h.
              </strong>
            </p>
          </div>
        </div>
      </div>

      <div className="doubt doubt--margin-top">
        <div className="doubt__box-question">
          <div className="doubt__question">
            <h3>Pergunta</h3>
          </div>
          <div>
            <p>
              <strong>
                Quais os modelos de contrato padrão de aceitação Alelo?
              </strong>
            </p>
          </div>
        </div>
        <div className="doubt__box-answer">
          <div className="doubt__answer">
            <h3>Resposta</h3>
          </div>
          <div>
            <p>
              Cada cartão da Alelo possui seu respectivo contrato.
              <br />
              Para conferir os contratos padrões de aceitação Alelo na íntegra,{' '}
              <a
                className="doubt__link"
                data-testid="doubt-link"
                onClick={() => openContracts()}
                href="https://www.alelo.com.br/estabelecimentos/contratos"
                target="blank"
              >
                clique aqui.
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
